import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllChattedChannel, getAllFollowedUsers, getAllTeamChannelWithoutJoin } from '../actions/chatActions';
import { all } from 'axios';


const initialState: any = {
    allFollowedUsers: [],
    allChattedChannel: [],
    allTeamChannelWithoutJoin: [],
    allTeamChannelWithJoin: []
};

const chatSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setChatClient(state, action: PayloadAction<any>) {
            state.chatClient = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllFollowedUsers.fulfilled, (state, action) => {
            state.allFollowedUsers = action.payload;
        });
        builder.addCase(getAllChattedChannel.fulfilled, (state, action) => {
            state.allChattedChannel = action.payload;
        });
        builder.addCase(getAllTeamChannelWithoutJoin.fulfilled, (state, action) => {
            state.allTeamChannelWithoutJoin = action.payload;
        });
        // builder.addCase(getAllTeamChannelWithJoin.fulfilled, (state, action) => {
        //     state.allTeamChannelWithJoin = action.payload;
        // });
    }
});

export const { setChatClient } = chatSlice.actions;

export default chatSlice.reducer;
